module.exports = __webpack_public_path__ + "static/media/SourceHanSerifCN-Light.4fd30a49.svg";